import { formatCurrency, formatDisplayDate, formatDateKeyFromMs, formatTime } from '../../utils/datetime';
import { KIND_LABELS, METHOD_LABELS, useWorkspaceSales } from '../../hooks/useWorkspaceSales';

const SalesDeposits = () => {
  const { data, loading, error } = useWorkspaceSales();
  const currency = data?.currency || 'GHS';
  const deposits = data?.deposits || [];
  const held = deposits.reduce((sum, item) => sum + (item.amount || 0), 0);

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-2xl font-light text-ink-900">Deposits</h2>
          <p className="mt-1 text-sm text-ink-700/80">
            Online deposits sitting against upcoming bookings. Full prepayments are listed here too
            until the visit happens.
          </p>
        </div>
        <p className="text-sm text-ink-700/80">
          Held now:{' '}
          <span className="font-medium text-ink-900">{formatCurrency(held, currency)}</span>
        </p>
      </div>

      {error && (
        <div className="border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</div>
      )}

      <ul className="divide-y divide-ink-900/10 bg-sand-50 ring-1 ring-ink-900/10">
        {loading ? (
          <li className="flex justify-center py-16">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink-900/20 border-t-saffron-500" />
          </li>
        ) : deposits.length === 0 ? (
          <li className="px-5 py-16 text-center text-sm text-ink-700/70">
            No paid deposits on upcoming bookings.
          </li>
        ) : (
          deposits.map((deposit) => (
            <li
              key={deposit.id}
              className="flex flex-col gap-2 px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
            >
              <div className="min-w-0">
                <p className="font-medium text-ink-900">{deposit.client}</p>
                <p className="mt-0.5 text-sm text-ink-700/75">
                  {deposit.service}
                  {deposit.startAt
                    ? ` · ${formatDisplayDate(formatDateKeyFromMs(deposit.startAt))} ${formatTime(
                        deposit.startAt
                      )}`
                    : ''}
                </p>
                <p className="mt-1 text-xs text-ink-600/55">
                  {METHOD_LABELS[deposit.method] || deposit.method}
                </p>
              </div>
              <div className="flex flex-none items-center gap-3">
                <span
                  className={`px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${
                    deposit.kind === 'full_payment'
                      ? 'bg-emerald-50 text-emerald-800'
                      : 'bg-saffron-500/15 text-saffron-800'
                  }`}
                >
                  {deposit.kind === 'full_payment' ? 'Paid in full' : KIND_LABELS.deposit}
                </span>
                <span className="font-medium tabular-nums text-ink-900">
                  {formatCurrency(deposit.amount, deposit.currency || currency)}
                </span>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default SalesDeposits;
